import { render, staticRenderFns } from "./FlexInfo.vue?vue&type=template&id=e951aef0&scoped=true&"
import script from "./FlexInfo.vue?vue&type=script&lang=js&"
export * from "./FlexInfo.vue?vue&type=script&lang=js&"
import style0 from "./FlexInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FlexInfo.vue?vue&type=style&index=1&id=e951aef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e951aef0",
  null
  
)

export default component.exports